import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SurfaceMaterialSlot } from './SurfaceMaterialSlot';
const DEFAULT_SURFACE = [undefined];
/** The sources to draw: a mesh that declares no surface material still draws Godot's default one. */
export function surfaceSources(sources) {
    return sources.length === 0 ? DEFAULT_SURFACE : sources;
}
/**
 * The attach key of draw group `index`. A mesh of one surface keeps the singular key, so
 * `mesh.material` stays one material rather than a length-1 array.
 */
export function surfaceAttach(index, surfaceCount) {
    return surfaceCount > 1 ? `material-${index}` : 'material';
}
export function SurfaceMaterialSlots({ sources, points, particles }) {
    const slotSources = surfaceSources(sources);
    return (_jsx(_Fragment, { children: slotSources.map((source, i) => (_jsx(SurfaceMaterialSlot, { source: source, attach: surfaceAttach(i, slotSources.length), points: points, particles: particles }, i))) }));
}
//# sourceMappingURL=SurfaceMaterialSlots.js.map